/* oxlint-disable @typescript-eslint/no-unused-vars */
import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, first } from "rxjs/operators";

import { NotificationsService } from "@hermes/aphrodite-layout-state";

import { CustomerSessionResponse } from "@hermes/api-model-account";
import { Context } from "@hermes/core-app-core";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { UserStateService } from "@hermes/hermes-web-states-user-state";

/**
 * Sync customer between rdr / ecom
 * If there is no cookie or no user datas in sessionStorage fetch it from ecom
 * Else return it from sessionStorage
 * It's will resolve
 * - cookie needed for ecom action (as add to cart)
 * - user informations
 * - user basket
 * - shippingAddresses
 * - availableCountries
 */
@Injectable()
export class CustomerSessionResolver {
    readonly #notificationsService = inject(NotificationsService);
    readonly #context = inject(Context);
    readonly #userService = inject(UserStateService);

    public resolve(
        _route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot,
    ): Observable<CustomerSessionResponse | undefined> {
        if (!this.#context.isInBrowserMode()) {
            return of(undefined);
        }

        /**
         * Fetch customerSession if not already done
         * Return true if user is not loggedIn, redirect to home page otherwise
         */
        return this.#userService.fetchCustomerSession(false).pipe(
            catchError((error: HttpErrorResponse) => {
                // In case of error, show technical error notification, and dont crash the resolve
                // (it must go through for the notification component to be loaded)
                this.#notificationsService.technicalError(
                    "Error fetching customer session",
                    error,
                );
                return of(undefined);
            }),
            first(),
        );
    }
}
